import React from 'react';
import { i18n } from '@lingui/core';
import { parseISODate } from '@ygtechnologies/rubus-frontend-utilities';

interface IOwnProps {
    value: Date | string;
}

function DateTimeDisplay({ value }: IOwnProps) {
    if (!value) {
        return null;
    }
    return (
        <>
            {i18n.date(parseISODate(value), {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            })}
        </>
    );
}

export default React.memo(DateTimeDisplay);
